/**
 * Whether the credits panel may print "… allotment resets on {date}." (#740)
 *
 * The sentence makes a promise about ONE allotment: the billed pool's, whose Stripe
 * billing period is where the date comes from and whose name the sentence carries.
 * So it may only appear when that pool was actually granted an allotment for the
 * period the date closes — `monthlyAllotment` is exactly that grant. A period that
 * granted nothing (a fully discounted renewal, or a grant that has not posted yet)
 * has a period end but no allotment to reset, and the panel showed the promise with
 * no allotment figures anywhere above it.
 *
 * Deliberately NOT `totals.hasAllotment`, which is what draws the bar. That is summed
 * across every pool since #724, so it is true when a *team* pool has an allotment and
 * the billed pool has none — and the sentence would then promise a reset for "your"
 * credits on the strength of someone else's. The narrower test is also sufficient for
 * the bar: a pool granted an allotment this period has positive allotment lines, so
 * `monthlyAllotment > 0` implies `totals.hasAllotment`, and the sentence can never be
 * orphaned.
 *
 * The date is still required: a free-tier payload carries no period at all.
 *
 * Both inputs are permissive because the panel must render an older or partial server
 * payload as a missing figure rather than an exception.
 */
export function shouldShowAllotmentReset(
    resetDate: string | null | undefined,
    monthlyAllotment: number | null | undefined,
): boolean {
    return !!resetDate && (monthlyAllotment || 0) > 0;
}
